
import { defineComponent, PropType } from 'vue'
import { IntegrationShortcodes } from '~/mixins/integrationsDetailMixin'
import { descriptionMap } from '~/types/integrations'
import { IntegrationProviderStatus } from '~/types/types'

enum IntegrationCardStatus {
  ERROR = 'Error',
  INSTALLED = 'Installed',
  CONNECT = 'Connect'
}

/**
 * Component that renders the integration cards in the list view
 */
export default defineComponent({
  name: 'IntegrationCard',

  props: {
    shortcode: {
      type: String as PropType<IntegrationShortcodes>,
      required: true
    },
    logo: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    installed: {
      type: Boolean,
      required: true
    },
    status: {
      type: String as PropType<IntegrationProviderStatus>,
      default: null
    },
    baseRoute: {
      type: String,
      required: true
    },
    featureGated: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      descriptionMap,
      IntegrationCardStatus
    }
  },

  computed: {
    currentStatus(): IntegrationCardStatus {
      return this.status === IntegrationProviderStatus.Error
        ? IntegrationCardStatus.ERROR
        : this.installed
          ? IntegrationCardStatus.INSTALLED
          : IntegrationCardStatus.CONNECT
    }
  }
})
